module.exports = __webpack_public_path__ + "static/media/bold.56632c8f.svg";